export const environment = {
  production: false,
  apiProjectUrl: "https://a314-projects-uat.thevillageph.avwaveinteractive.com/projects",
  apiUrlAdmin:
    "https://a314-admin-users-uat.thevillageph.avwaveinteractive.com/admin-users",
  apiGoogleStorage:
    "https://a314-google-storage-uat.thevillageph.avwaveinteractive.com/storage",
  urlStorage: "https://storage.googleapis.com/thevillageph-avwave-uat/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};
